import "./index.css";
import { apiRequest, acfReady } from "../../utils/utils.js";
import { dropdownClickHandler } from "./elements/dropdown.js";
import { inputChangeHandler, addEventListeners } from "./elements/input.js";
import { addLocationShareButton } from "./elements/locationShare.js";

export default function () {
	async function init() {
		const context = {
			selector: ".acf-map-container > input[type=search]",
			dropdownClassname: "acf-address-dropdown",
			apiSuggestUrl:
				"https://api.pdok.nl/bzk/locatieserver/search/v3_1/suggest",
			apiLookupUrl: "https://api.pdok.nl/bzk/locatieserver/search/v3_1/lookup",
			apiReverseUrl:
				"https://api.pdok.nl/bzk/locatieserver/search/v3_1/reverse",
			suggestMaxResults: 5,
			apiSuggestRowsParam: "rows=",
			apiSuggestQueryParam: "q=",
			apiLookupIdParam: "id=",
			apiRequest,
		};

		/// Todo Frontend: A11y make it so with arrows keys you can select focus on dropdown!

		// Step 1 - Wait for all ACF fields to be ready
		await acfReady();

		// Step 2 - create both event handlers functions
		const dropdownHandler = dropdownClickHandler(context);
		context.inputHandler = inputChangeHandler({
			...context,
			dropdownHandler,
		});

		// Step 3 - Find all custom map address fields
		const fields = document.querySelectorAll(context.selector);
		if (!fields.length) return;

		// Step 4 - add event handlers to each field
		fields.forEach((field, index) => {
			addEventListeners(field, context.inputHandler, context.dropdownClassname);
			addLocationShareButton(field, index, context);
		});
	}

	init();
}
